import { Button, useTheme } from "@mui/material";

export default function MicrosoftButton({ onClick }) {
  const theme = useTheme();
  const p  = theme.palette.login;      // actual values — for SVG fill attributes
  const pv = theme.vars.palette.login; // CSS var refs — for boxShadow template strings

  const microsoftLogo = (
    <svg width="20" height="20" viewBox="0 0 21 21" aria-hidden="true" focusable="false">
      <rect x="0"  y="0"  width="9.5" height="9.5" fill={p.msLogoRed}    />
      <rect x="11" y="0"  width="9.5" height="9.5" fill={p.msLogoGreen}  />
      <rect x="0"  y="11" width="9.5" height="9.5" fill={p.msLogoBlue}   />
      <rect x="11" y="11" width="9.5" height="9.5" fill={p.msLogoYellow} />
    </svg>
  );

  const styles = {
    button: {
      height: "54px",
      bgcolor: "login.msButtonBg",
      color: "login.msButtonText",
      borderColor: "login.msButtonBorder",
      borderRadius: "6px",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
      fontSize: "16px",
      fontWeight: 600,
      textTransform: "none",
      boxShadow: `0 2px 8px ${pv.msButtonShadow}`,
      transition: "box-shadow 120ms ease, transform 120ms ease",
      "&:hover": {
        bgcolor: "login.msButtonBgHover",
        borderColor: "login.msButtonBorder",
        boxShadow: `0 8px 22px ${pv.msButtonShadowHover}`,
        transform: "translateY(-1px)",
      },
      "&:active": {
        transform: "translateY(1px)",
      },
    },
  };

  return (
    <Button
      variant="outlined"
      fullWidth
      onClick={onClick}
      startIcon={microsoftLogo}
      sx={styles.button}
    >
      Sign in with Microsoft
    </Button>
  );
}
